import React, { useState } from "react";
import {  Navigate } from "react-router-dom";
import axios from "axios";
import Navbar from "../Navbar";
const SERVER_URL = process.env.REACT_APP_SERVER_URL

// import Form from '../form';
// import '../form.css';
// import { set } from 'mongoose';

const SignUp = () => {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [redirect, setRedirect] = useState(false);
  //   redirect: localStorage.getItem('userTokenTime') ? true : false

  const onSubmitHandler = (e) => {
    e.preventDefault();
    console.log(redirect);

    if (
      !(fname === "" || lname === "" || email === "" || password === "") &&
      // eslint-disable-next-line
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
        axios
          .post(
            SERVER_URL+
            "/api/signup",
            {
              first_name: fname,
              last_name: lname,
              email: email,
              password: password,
            }
            // {
            //   headers: {
            //     "Content-Type": "application/json",
            //     // header2: value2
            //   },
            // }
          )
          .then((res) => {
            setRedirect((prev) => !prev);
          })
          .catch((err) => {
            console.log(err);
          });;
    } else {
      alert("Please enter valid details");
    }
  };

  if (redirect) return <Navigate to="/" />;
  return (
    <>
    <Navbar/>
      <form
        id="login-form"
        className="form form-section"
        method="post"
        onSubmit={(e) => onSubmitHandler(e)}
      >
        <h3 className="mx-3" style={{ color: "#00ADEF" }}>
          Register
        </h3>
        <p className="mx-3">Sign up with your email to get started</p>

        <div className="form-group mx-3">
          <label htmlFor="first-name" style={{ color: "#00ADEF" }}>
            First Name:
          </label>
          <input
            id="first-name"
            className="form-control"
            type="text"
            name="first_name"
            placeholder="First Name"
            onChange={(e) => setFname(e.target.value)}
            required
          />
        </div>
        <div className="form-group mx-3">
          <label htmlFor="last-name" style={{ color: "#00ADEF" }}>
            Last Name:
          </label>
          <input
            id="last-name"
            className="form-control"
            type="text"
            name="last_name"
            placeholder="Last Name"
            onChange={(e) => setLname(e.target.value)}
            required
          />
        </div>
        <div className="form-group mx-3">
          <label htmlFor="email" style={{ color: "#00ADEF" }}>
            Email:
          </label>
          <input
            id="email"
            className="form-control"
            type="email"
            name="email"
            placeholder="example@domain.com"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group mx-3">
          <label htmlFor="password" style={{ color: "#00ADEF" }}>
            Password:
          </label>
          <input
            id="password"
            className="form-control"
            type="password"
            name="password"
            placeholder="********"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <p className="mx-3 ">By continuing, you agree to Store's Terms of Use and Privacy Policy.</p>

        <div className="d-grid mx-3">
          <input
            type="submit"
            name="submit"
            className="btn btn-md mt-2"
            style={{ backgroundColor: "#00ADEF", color: "white" }}
            value="Submit"
            onClick={(e) => {
              onSubmitHandler(e);
            }}
          />
          {/* <Link to="/signIn"  style={{color:"#00ADEF",textDecoration:"none",background:"none"}}>Login here</Link> */}
        </div>
      </form>
    </>
  );
};

export default SignUp;
